


























































import { Vue, Component } from "vue-property-decorator"

const AppProps = Vue.extend({
	props: {
		availableTags: {
			type: Array,
			required: true
		}
	}
})

@Component({})
export default class DropdownForm extends AppProps {
	search = ""
	value: string[] = []
	disabled = false

	get searchDesc() {
		return this.availableOptions.length === 0 ? "Der er ingen kriterier der matcher din søgning." : ""
	}

	get criteria() {
		// Compute the search criteria
		return this.search.trim().toLowerCase()
	}

	get availableOptions() {
		const criteria = this.criteria
		// Filter out already selected options
		const options = this.availableTags.filter(
			// @ts-ignore
			opt => this.value.indexOf(opt) === -1
		)
		if (criteria) {
			// Show only options that match criteria
			return options.filter(
				// @ts-ignore
				opt => opt.toLowerCase().indexOf(criteria) > -1
			)
		}
		// Show all options available
		return options
	}

	// @ts-ignore
	onOptionClick({ option, tags, addTag }) {
		addTag(option)
		this.search = ""
		this.$root.$emit("recipeSearchUpdated", tags.concat(option))
	}

	// @ts-ignore
	remove({ tag, tags, removeTag }) {
		const index = tags.indexOf(tag)
		removeTag(tag)
		this.$root.$emit("recipeSearchUpdated", tags.splice(index, 1))
	}
}
